<template>
    <div class="device-type-stats">
        <!-- 视频播放容器 -->
        <div id="liveContainer" ref="liveContainer"></div>
    </div>
</template>

<script>
export default {
    name: "DemoPlayer",
    component: {
    },
    props: {
        url: { type: String, default: "" },
        // 播放屏幕显示个数
        isShowOperateBtns: {
            type: Number,
            default: () => {
                return 1
            }
        },
        showPTZ: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        // 是否在重连时强制重新请求播放地址
        reconnectRefreshUrl: {
            type: Boolean,
            default: false
        },
        devcieID: NaN,
        HorizonSpeed: {},
        VerticalSpeed: {},

    },
    watch: {
        isShowOperateBtns: {
            handler: async function () {
                await this.recreateAndPlay()
            }
        },
        url(){
            this.manualStop = false;
            this.play();
        },
    },
    data() {
        return {
            live: null,
            wasm: true,
            vc: "ff",
            playing: true,
            quieting: true,
            loaded: false, // mute
            showOperateBtns: true,
            err: "",
            speed: 0,
            performance: "",
            volume: 1,
            rotate: 0,
            vod: true,
            forceNoOffscreen: true,
            buffer: 0.2,
            changeResizeModel: false,
            cent_Show: false,
            loading: false,
            timeout: null,
            timeSlidertimer: null, // 可滑动时间轴
            timeCells: [
                {
                    beginTime: new Date().getTime() - 3 * 3600 * 1000,
                    endTime: new Date().getTime() - 1 * 3600 * 1000,
                    style: {
                        background: 'rgba(132, 244, 180, 0.498039)'
                    }
                },
                {
                    beginTime: new Date().getTime() - 6 * 3600 * 1000,
                    endTime: new Date().getTime() - 4 * 3600 * 1000,
                    style: {
                        background: 'rgba(132, 244, 180, 0.498039)'
                    }
                }
            ],
            stampStartTime: 0,
            stampEndTime: 0,
            newUrl: "",
            remoteVideo:null,
            videoHeight:0,
            videoWidth:0,
            remoteBox:null,
            restartNum: 0,
            maxRestartNum: 8,
            reconnectBaseDelay: 1000,
            reconnectMaxDelay: 15000,
            reconnectTimer: null,
            manualStop: false,
            isDestroying: false,
            currentPlayUrl: "",
            isReconnecting: false,
            isOffline: false,
            preferMSE: false,
            preferDemuxWorker: false,
            preferWebGPU: false,
            playWatchdogTimer: null,
            playWatchdogMs: 12000,
            stallCheckTimer: null,
            lastFrameTime: 0,
            lastVideoCurrentTime: 0,
        };
    },
    beforeDestroy() {
        window.removeEventListener("online", this.handleOnline);
        window.removeEventListener("offline", this.handleOffline);
        this.destroyVideo();
    },
    async mounted() {
        // await this.create();
        // window.onerror = (msg) => (this.err = msg);
        window.addEventListener("online", this.handleOnline);
        window.addEventListener("offline", this.handleOffline);
    },
    methods: {
        getVideoHeightWidth () {
            this.remoteBox = document.getElementById('liveContainer');
            this.remoteVideo = this.remoteBox.querySelector("video");
            this.videoHeight = this.remoteVideo.videoHeight
            this.videoWidth = this.remoteVideo.videoWidth
            return {
                videoHeight:this.videoHeight,
                videoWidth:this.videoWidth,
                offsetHeight:this.remoteVideo.offsetHeight,
                offsetWidth:this.remoteVideo.offsetWidth,
                offsetLeft:this.remoteVideo.offsetLeft,
                offsetTop:this.remoteVideo.offsetTop
            }
        },
        // 实例化 jessibuca 插件
        create() {
            if (this.live) return;
            let jessibucaDemo = null;
            jessibucaDemo = {
                container: this.$refs.liveContainer,
                videoBuffer: 0.2, // 设置最大缓冲时长，单位秒，播放器会自动消除延迟。
                videoBufferDelay: 1, // 视频缓冲区延迟
                isResize: true, // 当为true的时候：视频画面做等比缩放后,高或宽对齐canvas区域,画面不被拉伸,但有黑边。
                text: "",
                loadingText: "加载中", //  加载过程中文案。
                debug: false, //
                debugLevel: "debug",
                useMSE: false, // 稳定优先，必要时再启用 MSE
                useSIMD: false,
                useWCS: false, // 否开启Webcodecs硬解码
                showBandwidth: true, // 显示网速
                showPerformance: false,
                operateBtns: {  // 配置操作按钮 
                    fullscreen: this.showOperateBtns, // fullscreen 是否显示全屏按钮
                    screenshot: this.showOperateBtns,  // screenshot 是否显示截图按钮
                    play: this.showOperateBtns, // play 是否显示播放暂停按钮
                    audio: this.showOperateBtns, // audio 是否显示声音按钮
                    ptz: this.showPTZ, // 是否显示 上下左右控制器按钮
                    // performance:true, // 是否显示性能按钮
                    zoom:true, // 是否显示 放大缩小
                    record: this.showOperateBtns, // record 是否显示录制按钮
                },
                // hasAudio:false,
                timeout: 10000, // 设置超时时长, 单位秒
                heartTimeoutReplayUseLastFrameShow: true,
                heartTimeoutReplay: true,
                heartTimeoutReplayTimes: 3,
                loadingTimeout: 10,
                loadingTImeoutReplay: true,
                loadingTImeoutReplayTimes: 3,
                audioEngine: "worklet",
                qualityConfig: ['普清', '高清', '超清', '4K', '8K'],
                forceNoOffscreen: this.forceNoOffscreen, //是否不使用离屏模式（提升渲染能力）
                isNotMute: false,
                heartTimeout: 10, // 设置超时时长, 单位秒
                ptzClickType: "mouseDownAndUp", // 控制器类型: 点击显示
                ptzZoomShow: false, // 视频控制器按钮 左上, 右上, 右下, 左下
                ptzMoreArrowShow: false, // 是否显示ptz zoom(镜头) 按钮
                ptzApertureShow: false, // 是否显示ptz aperture（聚焦） 按钮
                ptzFocusShow: false, // 是否显示ptz focus（光圈） 按钮
                useCanvasRender: true,
                useWebGPU: this.preferWebGPU,
                demuxUseWorker: this.preferDemuxWorker,
            }
            jessibucaDemo.useMSE = this.preferMSE;
            this.live = new window.JessibucaPro(jessibucaDemo);

            // 暂停
            this.live.on("pause", () => {
                this.playing = false;
            });

            //暂停后重新播放
            this.live.on("play", async () => {
                this.restartNum = 0;
                this.playing = true;
                this.loading = false;
                this.clearPlayWatchdog();
                this.startStallCheck();
                this.lastFrameTime = Date.now();
                this.$emit("onplay",true)
            });

            this.live.on("websocketError", () => {
                this.handleStreamDisconnect("websocketError");
            })

            this.live.on("websocketClose", () => {
                this.handleStreamDisconnect("websocketClose");
            })
            // jessibuca 控制上下左右按钮
            this.live.on("ptz",  (arrow) => {
                this.live.getPTZCmd(arrow)
                this.$emit('ptz', arrow)
                if (!this.devcieID) return;
                // if (arrow != 'stop') {
                //     this.$API.device.cameraControl.post(this.devcieID, {
                //         Command: arrow + '',
                //         HorizonSpeed: this.HorizonSpeed,
                //         VerticalSpeed: this.VerticalSpeed,
                //     })
                // } else {
                //     clearTimeout(this.timeout)
                //     this.$API.device.cameraControl.post(this.devcieID, {
                //         Command: 'stop',
                //         HorizonSpeed: 30,
                //         VerticalSpeed: 30,
                //     })
                // }
            });

            // 返回卡顿程度
            this.live.on("performance", performance => {
                this.lastFrameTime = Date.now();
                var show = "卡顿";
                if (performance === 2) {
                    show = "非常流畅";
                } else if (performance === 1) {
                    show = "流畅";
                }
                this.performance = show;
            });

        },
        destroy() {
            if(!this.live) return
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            this.isDestroying = true;
            Promise.resolve(this.live.destroy()).finally(() => {
                this.live = null;
                this.isDestroying = false;
            });
        },
        // 播放视频
        async play(url) {
            const targetUrl = url || this.currentPlayUrl || this.url;
            if (!targetUrl) return;
            this.manualStop = false;
            this.currentPlayUrl = targetUrl;
            this.clearReconnectTimer();
            this.loading = true;
            this.startPlayWatchdog("play");
            if (!this.live) {
                this.create();
            }
            if (!this.live || this.isDestroying) return;
            this.live.play(targetUrl);
        },
        // 触发声音事件
        mute() {
            this.live.mute();
        },

        // 取消静音
        cancelMute() {
            this.live.cancelMute();
        },
        // 暂停
        pause() {
            this.manualStop = true;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            this.live.pause();
            this.playing = false;
            this.err = "";
            this.performance = "";
        },

        // 设置音量
        volumeChange() {
            this.live.setVolume(this.volume);
        },

        // 旋转角度
        rotateChange() {
            this.live.setRotate(this.rotate);
        },

        // 截图
        screenShot() {
            try {
                const imgData = this.live.screenshot("test", "png", 0.92, 'base64');
                this.$emit("screenShot", imgData)
                return imgData
            } catch{
                return null
            }
        },
        close() {
            this.manualStop = true;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            if (this.live) {
                this.live.close();
            }
        },
        destroyVideo() {
            this.manualStop = true;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            if( this.live ){
                this.live.destroy();
            }
            this.live = null;
            this.playing = false;
        },
        clearReconnectTimer() {
            if (this.reconnectTimer) {
                clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }
        },
        getReconnectDelay() {
            const delay = this.reconnectBaseDelay * Math.pow(2, this.restartNum);
            return Math.min(delay, this.reconnectMaxDelay);
        },
        async recreateAndPlay() {
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            if (this.live && !this.isDestroying) {
                await this.live.destroy();
                this.live = null;
            }
            this.create();
            await this.play();
        },
        async rebuildPlayerAndPlay(url) {
            const targetUrl = url || this.currentPlayUrl || this.url;
            if (!targetUrl) return;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            if (this.live && !this.isDestroying) {
                await Promise.resolve(this.live.destroy());
                this.live = null;
            }
            this.create();
            await this.play(targetUrl);
        },
        clearPlayWatchdog() {
            if (this.playWatchdogTimer) {
                clearTimeout(this.playWatchdogTimer);
                this.playWatchdogTimer = null;
            }
        },
        startPlayWatchdog(reason) {
            this.clearPlayWatchdog();
            this.playWatchdogTimer = setTimeout(async () => {
                if (this.manualStop || !this.loading) return;
                console.warn("[videoLive] 播放超时未出图，触发恢复", { reason, playWatchdogMs: this.playWatchdogMs });
                this.$emit("reconnect-scheduled", { reason: "playWatchdogTimeout", nextAttempt: this.restartNum + 1, delay: 0 });
                await this.handleStreamDisconnect("playWatchdogTimeout");
            }, this.playWatchdogMs);
        },
        clearStallCheck() {
            if (this.stallCheckTimer) {
                clearInterval(this.stallCheckTimer);
                this.stallCheckTimer = null;
            }
        },
        startStallCheck() {
            this.clearStallCheck();
            this.lastFrameTime = Date.now();
            this.lastVideoCurrentTime = 0;
            this.stallCheckTimer = setInterval(async () => {
                if (this.manualStop || !this.live) return;
                const liveContainer = this.$refs.liveContainer;
                if (liveContainer) {
                    const videoDom = liveContainer.querySelector("video");
                    if (videoDom && !Number.isNaN(videoDom.currentTime)) {
                        if (videoDom.currentTime > this.lastVideoCurrentTime) {
                            this.lastVideoCurrentTime = videoDom.currentTime;
                            this.lastFrameTime = Date.now();
                            if (this.loading) this.loading = false;
                        }
                    }
                }
                const noFrameTooLong = Date.now() - this.lastFrameTime > 15000;
                if (noFrameTooLong && !this.loading && !this.isReconnecting) {
                    console.warn("[videoLive] 画面疑似卡死，触发恢复");
                    await this.handleStreamDisconnect("renderStall");
                }
            }, 5000);
        },
        // 网络断开时暂停自动重连，避免浪费重连次数，等网络恢复后再恢复
        handleOffline() {
            this.isOffline = true;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
        },
        // 网络恢复时主动恢复播放
        async handleOnline() {
            this.isOffline = false;
            if (this.manualStop || this.isDestroying) return;
            const targetUrl = this.currentPlayUrl || this.url;
            if (!this.devcieID && !targetUrl) return;
            const frameAlive = Date.now() - this.lastFrameTime < 15000;
            const playingNormal = this.live && this.playing && !this.loading && !this.isReconnecting && frameAlive;
            if (playingNormal) return;
            this.restartNum = 0;
            this.isReconnecting = false;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            this.clearStallCheck();
            this.err = "";
            this.$emit("reconnect-scheduled", { reason: "networkOnline", nextAttempt: 1, delay: 0 });
            if (this.devcieID) {
                try {
                    await this.getNewUrl();
                } catch (error) {
                    console.error("[videoLive] 网络恢复后重新获取播放地址失败", error);
                    this.handleStreamDisconnect("onlineRefreshUrlError");
                }
            } else {
                await this.rebuildPlayerAndPlay(targetUrl);
            }
        },
        async handleStreamDisconnect(reason) {
            if (this.manualStop) return;
            if (this.isReconnecting) return;
            this.loading = true;
            this.clearReconnectTimer();
            this.clearPlayWatchdog();
            if (this.isOffline) {
                return;
            }
            if (this.restartNum >= this.maxRestartNum) {
                this.loading = false;
                this.err = `重连失败，已达到最大次数(${this.maxRestartNum})`;
                this.$emit("reconnect-failed", { reason, restartNum: this.restartNum });
                return;
            }
            const delay = this.getReconnectDelay();
            const nextAttempt = this.restartNum + 1;
            if (nextAttempt >= 2) {
                // decoderWorker 出错后切到兼容模式，避免 worker 继续崩溃导致有流量无画面
                this.preferDemuxWorker = false;
                this.preferMSE = false;
            }
            console.warn(`[videoLive] 流断开，准备重连`, { reason, nextAttempt, delay });
            this.$emit("reconnect-scheduled", { reason, nextAttempt, delay });
            this.reconnectTimer = setTimeout(async () => {
                this.isReconnecting = true;
                this.restartNum = nextAttempt;
                try {
                    if (this.devcieID) {
                        await this.getNewUrl();
                    } else {
                        const reconnectUrl = this.currentPlayUrl || this.url;
                        await this.rebuildPlayerAndPlay(reconnectUrl);
                    }
                } catch (error) {
                    console.error("[videoLive] 重连失败", error);
                    this.handleStreamDisconnect("reconnectError");
                } finally {
                    this.isReconnecting = false;
                }
            }, delay);
        },

        // 获取新的播放地址
        async getNewUrl() {
            let res = await this.$API.device_camera.play.get(this.devcieID, {
                play: "start"
            })
            if (res.data) {
                if (window.location.protocol == "http:") {
                    this.newUrl = res.data.ws_flv
                } else {
                    this.newUrl = res.data.wss_flv
                }
                this.currentPlayUrl = this.newUrl
                await this.rebuildPlayerAndPlay(this.newUrl)
            }
        }
    },

};
</script>

<style lang="scss" scoped>
.timeSlider {
    width: 99.8%;
    height: 30px;
}

.device-type-stats {
    height: 100%;
    width: 100%;
    background-color: rgba(243, 250, 250, .2);
    border-radius: 2px;
    backdrop-filter: blur(1px);
    position: relative;
}

#liveContainer {
    //  min-width: 300px;
    //  min-height: 500px;
    height: 100%;
    width: 100%;
}

.topBox {
    width: 70px;
    height: 70px;
    position: absolute;
    right: 0px;
    top: 0px;
    background-color: rgba(68, 157, 240, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-wrap: wrap;
    border-radius: 15px;
    font-size: 18px;

    i {
        font-size: 45px;
    }

}
</style>
